import { OverviewController } from './overview.controller';
import template from './overview.html';

export const overviewComponent = {
  name: 'overviewComponent',
  restrict: 'E',
  template,
  controller: OverviewController,
  controllerAs: 'vm',
  bindings: {},
};



// WEBPACK FOOTER //
// ./src/app/components/overview/overview.component.js